import { useBackend } from "../../services";

export const useCancelSpreadsheetImport = () => {
  const { deleteRequest } = useBackend();
  return async () => {
    return await deleteRequest("xlsx/import");
  };
};
